/* eslint-disable complexity */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { ArrowBackIosNew } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { HEADER } from '../../../utils/User/contants'
import style from './index.module.css'
import Button from '../Button'
import NavDrawer from '../Drawer'
import {
  commonLinks, publicLinks, privateLinks, cartLinks,
} from '../../../utils/User/constants/header/mobileHeader'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'

const Header = (props) => {
  const { cartItem, handleLogout } = props
  const [ headerLinks, setHeaderLinks ] = useState([])
  const location = useLocation()
  const history = useHistory()
  const { user } = useSelector((state) => state.login)
  const path = location.pathname

  useEffect(() => {
    const headerLink = []
    if (user) {
      headerLink.push(...commonLinks, ...cartLinks, ...privateLinks)
    } else {
      headerLink.push(...commonLinks, ...cartLinks, ...publicLinks)
    }
    setHeaderLinks(headerLink)
  }, [ user ])

  const goBack = () => {
    history.goBack()
  }
  // Shift it in a container
  return (
    <>
      {/* <div className='container-fluid top-text'>
        <div className='row'>
          <div className='col-md-4 border border-dark text-center'>
            <p className='m-2'>
              <small>
                <i className='fa fa-shopping-cart fa-lg mr-1' aria-hidden='true' />
                FREE SHIPPING ON ALL ORDERS
              </small>
            </p>
          </div>
          <div className='col-md-4 border border-dark text-center'>
            <p className='m-2'>
              <small>
                <i className='fa fa-credit-card fa-lg mr-1' aria-hidden='true' />
                100% MONEY BACK GUARANTEE
              </small>
            </p>
          </div>
          <div className='col-md-4 border border-dark text-center'>
            <p className='m-2'>
              <small>
                <i className='fas fa-handshake fa-lg mr-1' aria-hidden='true' />
                ONLINE SUPPORT 24/7
              </small>
            </p>
          </div>
        </div>
      </div> */}
      <nav className='mb-1 justify-content-start navbar navbar-expand-lg navbar-dark bg-dark'>
        {(path !== ROUTE.HOME)
        && <ArrowBackIosNew sx={ { color: '#fff', margin: '0px 10px 0px 5px' } } onClick={ () => goBack() } />}
        <NavDrawer headerLinks={ headerLinks } />
        <Link className={ `navbar-brand ${ style.heading }` } to={ ROUTE.HOME }>{ HEADER }</Link>
        {/* <button
          className='navbar-toggler'
          type='button'
          data-toggle='collapse'
          data-target='#navbarSupportedContent-333'
          aria-controls='navbarSupportedContent-333'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon' />
        </button> */}
        {/* <div className='collapse navbar-collapse' id='navbarSupportedContent-333'>
          <ul className='navbar-nav mr-auto'>
            <li className='nav-item'>
              <Link
                className={ `nav-link ${ style.text } ${ path === ROUTE.PESTICIDES && style.active }` }
                to=ROUTE.PESTICIDES
              >
                Pesticide
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={ `nav-link ${ style.text } ${ path === ROUTE.FERTILIZER && style.active }` }
                to=ROUTE.FERTILIZER
              >
                Fertilizer
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={ `nav-link ${ style.text } ${ path === ROUTE.SEED && style.active }` }
                to=ROUTE.SEED
              >
                Seed
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={ `nav-link ${ style.text } ${ path === ROUTE.ANIMAL && style.active }` }
                to=ROUTE.ANIMAL
              >
                Animal
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={ `nav-link ${ style.text } ${ path === ROUTE.DAIRY && style.active }` }
                to=ROUTE.DAIRY
              >
                Dairy
              </Link>
            </li>
            <li className='nav-item'>
              <div className='dropdown'>
                <button
                  type='button'
                  className={ `btn dropdown-toggle ${ style.text } ` }
                  data-toggle='dropdown'
                >
                  Facilities
                </button>
                <div className={ `dropdown-menu ${ style.dropdownMenu }` }>
                  <Link
                    className={ `nav-link ${ style.text } ${ path === '/seminars' && style.active }` }
                    to='/seminars'
                  >
                    Seminars
                  </Link>
                  <Link
                    className={ `nav-link ${ style.text } ${ path === ROUTE.KCC && style.active }` }
                    to=ROUTE.KCC
                  >
                    KCC
                  </Link>
                  <Link
                    className={ `nav-link ${ style.text } ${ path === ROUTE.ADVISOR && style.active }` }
                    to=ROUTE.ADVISOR
                  >
                    Adviser
                  </Link>
                  <Link
                    className={ `nav-link ${ style.text } ${ path === ROUTE.APPLY && style.active }` }
                    to=ROUTE.APPLY
                  >
                    Apply
                  </Link>
                  <Link
                    className={ `nav-link ${ style.text } ${ path === '/contact' && style.active }` }
                    to='/contact'
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </li>
          </ul>
          <ul className='navbar-nav ml-auto nav-flex-icons'>
            {
              !localStorage.getItem('user') && (
                <>
                  <li className='nav-item'>
                    <Link
                      className={ `nav-link ${ style.text } ${ path === ROUTE.LOGIN && style.active }` }
                      to=ROUTE.LOGIN
                    >
                      Login
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={ `nav-link ${ style.text } ${ path === ROUTE.SIGNUP && style.active }` }
                      to=ROUTE.SIGNUP
                    >
                      Sign Up
                    </Link>
                  </li>
                </>
              )
            }
            {
              localStorage.getItem('user') && (
                <>
                  <li>
                    <Link
                      to=ROUTE.ACCOUNT
                      className={ `nav-link ${ style.text } ${ path === ROUTE.ACCOUNT && style.active }` }
                    >
                      <i className='fas fa-user fa-lg' />
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Button
                      className={ `nav-link ${ style.text }` }
                      onClick={ handleLogout }
                    >
                      Logout
                    </Button>
                  </li>
                </>
              )
            }
            <li className='nav-item'>
              <Link
                to=ROUTE.CART
                className={ `nav-link ${ style.text }  ${ style.cart } ${ path === ROUTE.CART && style.active }` }
              >
                <i className=' fas fa-shopping-cart' />
                <span className={ `badge ${ style.badge } rounded-pill bg-danger` }>{ cartItem }</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to=ROUTE.CART
                className={ `nav-link ${ style.text }  ${ style.cart } ${ path === '/notification' && style.active }` }
              >
                <i className='fa fa-bell' />
                <span className={ `badge ${ style.badge } rounded-pill bg-danger` }>{ cartItem }</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/twitter'
                className={ `nav-link ${ style.text } ${ path === '/twitter' && style.active }` }
              >
                <i className='fab fa-twitter fa-lg' />
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/facebook'
                className={ `nav-link ${ style.text } ${ path === '/facebook' && style.active }` }
              >
                <i className='fab fa-facebook-square fa-lg' />
              </Link>
            </li>
          </ul>
        </div> */}
      </nav>
    </>
  )
}
export default Header

Header.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  cartItem: PropTypes.number.isRequired,
}
